import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";


function TeamCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.text}</Card.Text>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Card.Text>{props.text1}</Card.Text>
        <Button variant="primary" href={props.ghLink} target="_blank">
       
          {props.isBlog ? "Blog" : "LinkedIn"}
        </Button>
       

      </Card.Body>
    </Card>
  );
}
export default TeamCards;
